<template>
  <v-container fluid class="pa-0">
    <v-card class="mx-3 elevation-2" style="border-radius:8px;">
      <v-tabs
        v-model="activeTab"
        color="primary"
        slider-color="white"
        dark
        show-arrows
        grow
      >
        <v-tab href="#tab-docs-empresa">
          <v-icon left>folder_shared</v-icon>
          Documentos de Empresa
        </v-tab>
        <v-tab href="#tab-catalogo">
          <v-icon left>menu_book</v-icon>
          Catálogo de Documentos
        </v-tab>
        <v-tab href="#tab-logo">
          <v-icon left>image</v-icon>
          Logo &amp; Datos
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">

        <!-- ─────────────────────────────────────────────────
             TAB 1: Documentos de la empresa (con semáforo)
        ───────────────────────────────────────────────────── -->
        <v-tab-item value="tab-docs-empresa">
          <v-container>
            <!-- Semáforo visual detallado -->
            <v-layout row wrap class="mb-3 mt-2" align-center>
              <v-flex xs12 sm4 class="pa-1">
                <v-card class="semacard semacard--green elevation-2">
                  <v-card-title class="pa-3">
                    <v-icon color="white" class="mr-2">check_circle</v-icon>
                    <span class="white--text headline font-weight-bold">{{ semaforo.green }}</span>
                  </v-card-title>
                  <v-card-text class="white--text pt-0">Documentos vigentes</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 class="pa-1">
                <v-card class="semacard semacard--yellow elevation-2">
                  <v-card-title class="pa-3">
                    <v-icon color="white" class="mr-2">warning</v-icon>
                    <span class="white--text headline font-weight-bold">{{ semaforo.yellow }}</span>
                  </v-card-title>
                  <v-card-text class="white--text pt-0">Próximos a vencer (30 días)</v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 class="pa-1">
                <v-card class="semacard semacard--red elevation-2">
                  <v-card-title class="pa-3">
                    <v-icon color="white" class="mr-2">cancel</v-icon>
                    <span class="white--text headline font-weight-bold">{{ semaforo.red }}</span>
                  </v-card-title>
                  <v-card-text class="white--text pt-0">Pendientes / Vencidos</v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- Acciones -->
            <v-layout row wrap align-center class="mb-3">
              <v-flex grow>
                <v-text-field
                  v-model="searchDocs"
                  append-icon="search"
                  label="Buscar documento"
                  single-line
                  hide-details
                  solo
                  class="search-field"
                ></v-text-field>
              </v-flex>
              <v-flex shrink class="pl-3">
                <v-btn color="primary" dark @click="openUploadDialog()">
                  <v-icon left>cloud_upload</v-icon>
                  Subir Documento
                </v-btn>
              </v-flex>
            </v-layout>

            <!-- Tabla de documentos -->
            <v-data-table
              :headers="headersDocsEmpresa"
              :items="docsEmpresaMerged"
              :loading="loadingDocs"
              :search="searchDocs"
              :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
              rows-per-page-text="Filas por página"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <!-- Estado semáforo -->
                <td style="width:48px;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        :color="statusColor(props.item.status)"
                      >{{ statusIcon(props.item.status) }}</v-icon>
                    </template>
                    <span>{{ statusLabel(props.item.status) }}</span>
                  </v-tooltip>
                </td>
                <td>{{ props.item.name_shown }}</td>
                <td>
                  <v-chip
                    small
                    :color="statusColor(props.item.status)"
                    text-color="white"
                    label
                  >{{ statusLabel(props.item.status) }}</v-chip>
                </td>
                <td>{{ props.item.valid_until | formatDate }}</td>
                <td>{{ props.item.uploaded_at | formatDate }}</td>
                <td class="text-xs-center">
                  <v-tooltip bottom v-if="props.item.id">
                    <template v-slot:activator="{ on }">
                      <v-icon medium class="mr-2" v-on="on" @click="viewDoc(props.item)">visibility</v-icon>
                    </template>
                    <span>Ver</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.id">
                    <template v-slot:activator="{ on }">
                      <v-icon medium class="mr-2" v-on="on" @click="editDoc(props.item)">edit</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.id">
                    <template v-slot:activator="{ on }">
                      <v-icon medium color="red" v-on="on" @click="confirmDeleteDoc(props.item)">delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!props.item.id">
                    <template v-slot:activator="{ on }">
                      <v-btn small flat color="primary" v-on="on" @click="openUploadDialogForDoc(props.item)">
                        <v-icon left small>cloud_upload</v-icon> Subir
                      </v-btn>
                    </template>
                    <span>Subir documento</span>
                  </v-tooltip>
                </td>
              </template>
              <template v-slot:no-data>
                <div class="text-xs-center py-4">
                  <v-icon size="48" color="grey lighten-1">folder_open</v-icon>
                  <p class="grey--text mt-2">No hay documentos cargados aún.</p>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>

        <!-- ─────────────────────────────────────────────────
             TAB 2: Catálogo de tipos de documento requeridos
        ───────────────────────────────────────────────────── -->
        <v-tab-item value="tab-catalogo">
          <v-container>
            <v-layout row wrap align-center class="mb-3 mt-2">
              <v-flex>
                <h3 class="subheading grey--text">Clasificación de documentos para invitaciones y empresa</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" dark @click="openCatalogoDialog()">
                  <v-icon left>add</v-icon>
                  Clasificar Documento
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="mb-4">
              <v-flex xs12 sm6 class="pa-1">
                <v-card class="catalog-card catalog-card--company elevation-1">
                  <v-card-text>
                    <div class="d-flex align-center mb-2">
                      <v-icon color="teal darken-2" class="mr-2">business</v-icon>
                      <span class="subheading font-weight-bold">Documento de empresa</span>
                    </div>
                    <p class="body-1 mb-1">La empresa lo sube una sola vez y se valida por vigencia en el expediente de la empresa.</p>
                    <p class="caption grey--text text--darken-1 mb-0">Si está vigente, puede evitar pedir ese documento al empleado en las invitaciones.</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-card class="catalog-card catalog-card--employee elevation-1">
                  <v-card-text>
                    <div class="d-flex align-center mb-2">
                      <v-icon color="blue darken-2" class="mr-2">assignment_ind</v-icon>
                      <span class="subheading font-weight-bold">Documento solicitado al empleado</span>
                    </div>
                    <p class="body-1 mb-1">Se pide directamente a cada empleado o invitado durante el proceso de invitación.</p>
                    <p class="caption grey--text text--darken-1 mb-0">Puede tener validación automática si aparece con el chip azul.</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="mb-2">
              <v-flex xs12 md6 class="pa-1">
                <v-card flat class="pa-2 catalog-section-title">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="subheading font-weight-bold">Documentos de empresa</div>
                      <div class="caption grey--text">Los carga la empresa para su propio expediente</div>
                    </div>
                    <v-chip small color="teal" text-color="white">{{ companyCatalogo.length }}</v-chip>
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12 md6 class="pa-1">
                <v-card flat class="pa-2 catalog-section-title">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="subheading font-weight-bold">Documentos solicitados al empleado</div>
                      <div class="caption grey--text">Se piden en invitaciones o en el expediente del empleado</div>
                    </div>
                    <v-chip small color="blue" text-color="white">{{ employeeCatalogo.length }}</v-chip>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 md6 class="pa-1">
                <v-data-table
                  :headers="headersCatalogo"
                  :items="companyCatalogo"
                  :loading="loadingCatalogo"
                  :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
                  rows-per-page-text="Filas por página"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon medium class="mr-2" v-on="on" @click="editCatalogo(props.item)">edit</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                    </td>
                    <td>
                      {{ props.item.name }}
                      <v-chip v-if="isOcrSupported(props.item.name)" small color="blue" text-color="white" class="ml-2">
                        <v-avatar class="blue darken-4"><v-icon small>check</v-icon></v-avatar>
                        Validación automática
                      </v-chip>
                      <v-chip small color="teal" text-color="white" class="ml-2">
                        <v-avatar class="teal darken-3"><v-icon small>business</v-icon></v-avatar>
                        Empresa
                      </v-chip>
                    </td>
                    <td>{{ props.item.description }}</td>
                  </template>
                  <template v-slot:no-data>
                    <div class="text-xs-center py-4">
                      <v-icon size="40" color="grey lighten-1">business</v-icon>
                      <p class="grey--text mt-2 mb-0">No hay documentos clasificados como de empresa.</p>
                    </div>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12 md6 class="pa-1">
                <v-data-table
                  :headers="headersCatalogo"
                  :items="employeeCatalogo"
                  :loading="loadingCatalogo"
                  :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
                  rows-per-page-text="Filas por página"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon medium class="mr-2" v-on="on" @click="editCatalogo(props.item)">edit</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                    </td>
                    <td>
                      {{ props.item.name }}
                      <v-chip v-if="isOcrSupported(props.item.name)" small color="blue" text-color="white" class="ml-2">
                        <v-avatar class="blue darken-4"><v-icon small>check</v-icon></v-avatar>
                        Validación automática
                      </v-chip>
                    </td>
                    <td>{{ props.item.description }}</td>
                  </template>
                  <template v-slot:no-data>
                    <div class="text-xs-center py-4">
                      <v-icon size="40" color="grey lighten-1">assignment_ind</v-icon>
                      <p class="grey--text mt-2 mb-0">No hay documentos clasificados para solicitar al empleado.</p>
                    </div>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>

        <!-- ─────────────────────────────────────────────────
             TAB 3: Logo y datos de empresa
        ───────────────────────────────────────────────────── -->
        <v-tab-item value="tab-logo">
          <v-container>
            <v-layout row wrap justify-center class="mt-4">
              <v-flex xs12 sm8 md6>
                <v-card class="elevation-3 pa-4" style="border-radius:12px;">
                  <v-card-title class="primary white--text mb-4" style="border-radius:8px 8px 0 0;">
                    <v-icon left dark>image</v-icon>
                    <span>Logo de la Empresa</span>
                  </v-card-title>
                  <v-card-text class="text-xs-center">
                    <div class="logo-preview-wrapper ma-auto mb-4">
                      <img v-if="empresa.logo" :src="empresa.logo" class="logo-preview" alt="Logo" />
                      <div v-else class="logo-placeholder">
                        <v-icon size="72" color="grey lighten-1">add_photo_alternate</v-icon>
                        <p class="grey--text">Sin logo</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      ref="logoFile"
                      accept="image/*"
                      style="display:none"
                      @change="handleLogoUpload"
                    />
                    <v-btn color="primary" @click="$refs.logoFile.click()">
                      <v-icon left>cloud_upload</v-icon>
                      {{ empresa.logo ? 'Cambiar Logo' : 'Subir Logo' }}
                    </v-btn>
                    <v-btn v-if="empresa.logo" color="error" flat class="ml-2" @click="deleteLogo()">
                      <v-icon left>delete</v-icon>
                      Eliminar
                    </v-btn>
                  </v-card-text>
                  <v-alert :value="logoOversized" type="error" outline class="mx-3">
                    El archivo es demasiado grande (máx. 2 MB).
                  </v-alert>
                  <v-divider class="mx-3 my-3"></v-divider>
                  <v-card-text>
                    <v-form ref="formEmpresa">
                      <v-text-field
                        v-model="empresa.name"
                        label="Nombre de la empresa"
                        prepend-icon="business"
                        :disabled="!editingEmpresa"
                      ></v-text-field>
                      <v-text-field
                        v-model="empresa.email"
                        label="Correo electrónico"
                        prepend-icon="email"
                        :disabled="!editingEmpresa"
                      ></v-text-field>
                      <v-text-field
                        v-model="empresa.address"
                        label="Dirección"
                        prepend-icon="location_on"
                        :disabled="!editingEmpresa"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn v-if="!editingEmpresa" color="primary" flat @click="editingEmpresa = true">
                      <v-icon left>edit</v-icon> Editar
                    </v-btn>
                    <template v-else>
                      <v-btn flat @click="cancelEditEmpresa()">Cancelar</v-btn>
                      <v-btn color="primary" :loading="loadingSaveEmpresa" @click="saveEmpresa()">Guardar</v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>

      </v-tabs-items>
    </v-card>

    <!-- ═══════════════════════════════════════════════════════════
         DIALOGS
    ════════════════════════════════════════════════════════════ -->

    <!-- Dialog: Subir / editar documento de empresa -->
    <v-dialog v-model="dialogUpload" max-width="560px" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-icon class="mr-2">cloud_upload</v-icon>
          <v-toolbar-title>{{ editingDoc ? 'Actualizar' : 'Subir' }} Documento de Empresa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeUploadDialog()"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-form ref="formUpload">
            <v-select
              v-model="docForm.idDocumentation"
              :items="companyDocOptions"
              item-text="name"
              item-value="id"
              label="Tipo de documento *"
              prepend-icon="description"
              :disabled="editingDoc"
              :error-messages="docErrors.idDocumentation"
              @change="resetOcrState"
            ></v-select>

            <!-- Checkbox para reemplazar archivo en modo edición -->
            <v-checkbox v-if="editingDoc" v-model="changeFile" label="Reemplazar archivo" @change="resetOcrState"></v-checkbox>

            <!-- Área de selección de archivo + resultado OCR -->
            <div v-if="!editingDoc || changeFile" class="mt-2">

              <!-- Estado: sin archivo -->
              <div v-if="!docOcrState.file && !docOcrState.loading"
                class="ocr-dropzone text-xs-center py-4"
                @click="$refs.docFileHidden.click()">
                <v-icon large color="grey darken-1">cloud_upload</v-icon>
                <div class="body-2 grey--text mt-2">Haz clic para seleccionar un archivo</div>
                <div class="caption grey--text">(PDF o imagen, máx. 10 MB)</div>
              </div>

              <!-- Estado: analizando OCR -->
              <div v-else-if="docOcrState.loading" class="text-xs-center py-4">
                <v-progress-circular indeterminate color="primary" class="mb-2"></v-progress-circular>
                <div class="body-2 blue--text">Analizando documento...</div>
              </div>

              <!-- Estado: resultado OCR -->
              <div v-else-if="docOcrState.file" class="ocr-result-card pa-3">
                <!-- Éxito -->
                <div v-if="!docOcrState.error" class="text-xs-center">
                  <v-icon large color="success">check_circle</v-icon>
                  <div class="body-2 green--text font-weight-bold mt-1">Documento validado correctamente</div>
                  <div v-if="docOcrState.validUntil" class="caption grey--text mt-1">
                    Vigente hasta: <strong>{{ docOcrState.validUntil }}</strong>
                  </div>
                  <div class="caption grey--text">{{ docOcrState.file.name }}</div>
                  <v-btn small flat color="primary" class="mt-2" @click="$refs.docFileHidden.click()">
                    <v-icon left small>edit</v-icon> Cambiar archivo
                  </v-btn>
                </div>
                <!-- Error -->
                <div v-else class="text-xs-center">
                  <v-icon large color="error">error_outline</v-icon>
                  <div class="body-2 red--text font-weight-bold mt-1">{{ docOcrState.error }}</div>
                  <div class="caption grey--text">{{ docOcrState.file.name }}</div>
                  <v-btn small outline color="error" class="mt-2" @click="$refs.docFileHidden.click()">
                    <v-icon left small>refresh</v-icon> Reintentar
                  </v-btn>
                </div>
              </div>

              <!-- Input oculto -->
              <input type="file" ref="docFileHidden" style="display:none" accept=".pdf,image/*" @change="handleDocFileUpload" />
              <v-alert :value="docOversized" type="error" outline class="mt-2">El archivo supera el tamaño máximo (10 MB).</v-alert>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeUploadDialog()">Cancelar</v-btn>
          <v-btn color="primary" :loading="loadingUpload" :disabled="!canSaveDoc" @click="saveDoc()">
            {{ editingDoc ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Nuevo/Editar catálogo -->
    <v-dialog v-model="dialogCatalogo" max-width="500px" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-icon class="mr-2">menu_book</v-icon>
          <v-toolbar-title>{{ editingCatalogo ? 'Editar' : 'Nuevo' }} Tipo de Documento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeCatalogoDialog()"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-form ref="formCatalogo">
            <v-alert
              :value="true"
              :type="catForm.is_company_document ? 'info' : 'warning'"
              outline
              class="mb-3"
            >
              <strong>{{ catForm.is_company_document ? 'Documento de empresa' : 'Documento solicitado al empleado' }}</strong>
              {{ catForm.is_company_document
                ? ' La empresa lo cargará en su expediente y su vigencia se evaluará a nivel empresa.'
                : ' Este documento se seguirá solicitando al empleado o invitado durante el proceso de invitación.' }}
            </v-alert>
            <v-select
              v-if="!editingCatalogo"
              v-model="catForm.idDocumentation"
              :items="availableDocumentations"
              item-text="name"
              item-value="id"
              label="Documento *"
              placeholder="Seleccione un documento del catálogo"
              prepend-icon="description"
              :error-messages="catErrors.idDocumentation"
              @change="onCatalogDocumentChange"
            >
              <template v-slot:item="data">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ data.item.name }}
                    <v-icon
                      v-if="isOcrSupported(data.item.name)"
                      small
                      color="blue"
                      class="ml-2"
                      title="Validación automática"
                    >verified_user</v-icon>
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
            <div v-else class="mb-3">
              <span class="caption grey--text text--darken-1">Documento</span>
              <div class="body-1 font-weight-bold">{{ catForm.displayName }}</div>
            </div>
            <div v-if="!editingCatalogo && catForm.description" class="mb-3">
              <span class="caption grey--text text--darken-1">Descripción</span>
              <div class="body-1">{{ catForm.description }}</div>
            </div>
            <v-switch
              v-model="catForm.is_company_document"
              :label="catForm.is_company_document ? 'Documento de empresa (no se solicita al empleado si la empresa lo tiene vigente)' : 'Documento de empleado'"
              color="teal"
              class="mt-2"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeCatalogoDialog()">Cancelar</v-btn>
          <v-btn color="primary" :loading="loadingCatalogo" @click="saveCatalogo()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Confirmar eliminación -->
    <v-dialog v-model="dialogDelete" max-width="340">
      <v-card>
        <v-card-title class="headline">¿Eliminar?</v-card-title>
        <v-card-text>Esta acción no se puede deshacer.</v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialogDelete = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" :loading="loadingDelete" @click="executeDelete()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import '@/plugins/axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'
import { USER_REQUEST } from '@/store/actions/user'

const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB
const LOGO_MAX_SIZE = 2 * 1024 * 1024  // 2 MB
const DAYS_TO_WARN  = 30

const OCR_NAMES = [
  'CURP',
  'RFC / Constancia de Situación Fiscal',
  'DC-3',
  'Opinión de Cumplimiento',
  'Cédula SUA',
  'Línea de Captura IMSS',
]

export default {
  name: 'GestionEmpresa',

  filters: {
    formatDate(val) {
      if (!val) return '—'
      const d = new Date(val)
      if (isNaN(d)) return val
      return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: '2-digit' })
    },
  },

  data() {
    return {
      activeTab: 'tab-docs-empresa',

      // Empresa
      empresa: { name: '', email: '', address: '', logo: null, id: null },
      editingEmpresa: false,
      loadingSaveEmpresa: false,
      logoOversized: false,

      // Semáforo
      semaforo: { green: 0, yellow: 0, red: 0 },

      // Docs empresa
      docsEmpresa: [],
      docsEmpresaStatus: [],
      loadingDocs: false,
      searchDocs: '',
      headersDocsEmpresa: [],

      // Catálogo
      catalogo: [],
      catalogoOptions: [],
      loadingCatalogo: false,
      headersCatalogo: [],
      documentations: [],
      editingDoc: false,
      changeFile: false,
      docFile: null,
      docOversized: false,
      loadingUpload: false,
      menuFechaVto: false,
      docForm: { idDocumentation: null, description: '', expiry_date: null },
      docErrors: {},
      // OCR validation state for upload dialog
      docOcrState: { file: null, loading: false, error: null, validUntil: null, ocrResult: null, skipped: false },
      ocrSupportedTypes: [],

      // Dialog catálogo
      dialogCatalogo: false,
      editingCatalogo: false,
      catForm: { idDocumentation: null, name: '', description: '', is_company_document: false, displayName: '' },
      catErrors: {},

      // Dialog eliminar
      dialogDelete: false,
      loadingDelete: false,
      deleteTarget: null,
      deleteType: null, // 'doc' | 'catalogo'
    }
  },

  computed: {
    ...mapGetters(['getProfile', 'isProfileLoaded']),
    ...mapState(['language']),
    ...mapGetters(['getProfile']),


    availableDocumentations() {
      if (!this.documentations) return []
      // Obtener IDs de documentos ya clasificados en el catálogo
      const catalogoIds = this.catalogo.map(c => c.id)
      // Filtrar documentos no clasificados como empresa y que no estén en el catálogo
      return this.documentations.filter(d => 
        !d.is_company_document && !catalogoIds.includes(d.id)
      )
    },
    companyCatalogo() {
      if (!this.catalogo) return []
      return this.catalogo.filter(item => item.is_company_document)
    },
    employeeCatalogo() {
      if (!this.catalogo) return []
      return this.catalogo.filter(item => !item.is_company_document)
    },
    companyDocOptions() {
      if (!this.documentations || !this.documentations.length) return []
      const withFlag = this.documentations.filter(d => d.is_company_document)
      return withFlag.length ? withFlag : this.documentations
    },
    canSaveDoc() {
      // In edit mode without file change: always allow
      if (this.editingDoc && !this.changeFile) return true
      // Need a file loaded and either OCR skipped (no server error) or OCR success and document is current
      if (!this.docOcrState.file || this.docOcrState.loading) return false
      if (this.docOcrState.skipped) return true
      return !this.docOcrState.error
    },
    // Merged table: status list (all doc types) enriched with uploaded file data
    docsEmpresaMerged() {
      return this.docsEmpresaStatus.map(statusItem => {
        const uploaded = this.docsEmpresa.find(d =>
          d.idDocumentation && d.idDocumentation.id === statusItem.documentation_id
        )
        return {
          // status fields
          documentation_id: statusItem.documentation_id,
          name_shown: statusItem.name,
          status: statusItem.status,
          // uploaded file fields (may be null if MISSING)
          id: uploaded ? uploaded.id : null,
          file: uploaded ? uploaded.file : null,
          is_valid: statusItem.is_valid,
          is_current: statusItem.is_current,
          valid_until: statusItem.valid_until,
          expiry_date: statusItem.valid_until,
          uploaded_at: uploaded ? uploaded.uploaded_at : null,
        }
      })
    },
  },

  beforeUpdate() {
    this.headersDocsEmpresa = [
      { text: '', value: 'status', sortable: false, width: '48px' },
      { text: 'Documento', value: 'name_shown', sortable: true },
      { text: 'Estado', value: 'estado', sortable: false },
      { text: 'Vencimiento', value: 'expiry_date', sortable: true },
      { text: 'Subido el', value: 'uploaded_at', sortable: true },
      { text: 'Acciones', value: 'actions', sortable: false, align: 'center' },
    ]
    this.headersCatalogo = [
      { text: 'Acciones', value: 'actions', sortable: false, align: 'center', width: '100px' },
      { text: 'Nombre', value: 'name', sortable: true },
      { text: 'Descripción', value: 'description', sortable: false },
    ]
  },

  watch: {
    isProfileLoaded(loaded) {
      if (loaded) this.fetchEmpresa()
    },
  },

  created() {
    if (this.isProfileLoaded) {
      this.fetchEmpresa()
    } else {
      this.$store.dispatch(USER_REQUEST)
    }
    this.fetchCatalogo()
    this.fetchDocumentations()
    this.fetchOcrTypes()
  },

  methods: {
    // ───────────────────── semáforo helpers ─────────────────────
    getSemaforoColor(item) {
      // New DocumentationByCompany items use is_valid / is_current / valid_until
      if ('is_valid' in item || 'is_current' in item) {
        if (item.is_valid === false) return 'red'
        if (item.is_current === false) return 'orange'
        if (item.valid_until) {
          const today = new Date()
          const exp   = new Date(item.valid_until)
          if (!isNaN(exp)) {
            const diffDays = Math.ceil((exp - today) / (1000 * 60 * 60 * 24))
            if (diffDays < 0)            return 'red'
            if (diffDays <= DAYS_TO_WARN) return 'orange'
          }
        }
        return 'green'
      }
      // Legacy items use expiry_date
      const dateVal = item.expiry_date || item.valid_until
      if (!dateVal) return 'grey'
      const today = new Date()
      const exp   = new Date(dateVal)
      if (isNaN(exp)) return 'grey'
      const diffDays = Math.ceil((exp - today) / (1000 * 60 * 60 * 24))
      if (diffDays < 0)            return 'red'
      if (diffDays <= DAYS_TO_WARN) return 'orange'
      return 'green'
    },
    getSemaforoIcon(item) {
      const c = this.getSemaforoColor(item)
      if (c === 'red')    return 'cancel'
      if (c === 'orange') return 'warning'
      if (c === 'green')  return 'check_circle'
      return 'help_outline'
    },
    getSemaforoLabel(item) {
      const c = this.getSemaforoColor(item)
      if (c === 'red')    return 'Vencido / Pendiente'
      if (c === 'orange') return 'Por vencer'
      if (c === 'green')  return 'Vigente'
      return 'Sin fecha'
    },
    recalcSemaforo() {
      this.semaforo.green = this.docsEmpresa.filter(d => this.getSemaforoColor(d) === 'green').length
      this.semaforo.yellow = this.docsEmpresa.filter(d => this.getSemaforoColor(d) === 'orange').length
      this.semaforo.red = this.docsEmpresa.filter(d => ['red', 'grey'].includes(this.getSemaforoColor(d))).length
    },
    isOcrSupported(name) {
      return OCR_NAMES.some(n => name && name.toLowerCase().includes(n.toLowerCase()))
    },
    statusColor(status) {
      if (status === 'OK')      return 'green'
      if (status === 'EXPIRED') return 'orange'
      if (status === 'INVALID') return 'red'
      return 'grey' // MISSING
    },
    statusIcon(status) {
      if (status === 'OK')      return 'check_circle'
      if (status === 'EXPIRED') return 'warning'
      if (status === 'INVALID') return 'cancel'
      return 'cloud_upload' // MISSING
    },
    statusLabel(status) {
      if (status === 'OK')      return 'Vigente'
      if (status === 'EXPIRED') return 'Vencido'
      if (status === 'INVALID') return 'Inválido'
      return 'Pendiente' // MISSING
    },
    openUploadDialogForDoc(statusItem) {
      this.editingDoc = false
      this.changeFile = false
      this.docFile = null
      this.docOversized = false
      this.docErrors = {}
      this.docOcrState = { file: null, loading: false, error: null, validUntil: null, ocrResult: null, skipped: false }
      this.docForm = { idDocumentation: statusItem.documentation_id, description: '', expiry_date: null }
      this.dialogUpload = true
    },

    // ───────────────────── fetch data ─────────────────────
    fetchEmpresa() {
      const idCompany = this.getProfile.id_company
      if (!idCompany) return
      const headers = { Authorization: 'Token ' + store.getters.getToken }
      axios({ method: 'get', url: `https://empresa-service.intrare.app/empresas/my-empresa`, headers })
        .then(res => {
          const data = res.data
          console.log('Empresa data:', data)
          this.empresa = {
            id:      data.id_empresa || data.id,
            name:    data.name     || '',
            email:   data.email      || '',
            address: data.address  || '',
            logo:    data.logo       || null,
          }
          this.fetchDocsEmpresa()
          this.fetchDocsEmpresaStatus()
        })
        .catch(() => {})
    },
    fetchDocsEmpresa() {
      if (!this.empresa.id) return
      this.loadingDocs = true
      const config = {
        method: 'get',
        url: `https://empresa-service.intrare.app/company-documents/${this.empresa.id}/`,
        headers: { Authorization: 'Token ' + store.getters.getToken },
      }
      axios(config).then(res => {
        this.docsEmpresa = (res.data || []).map(d => ({
          ...d,
          name_shown: d.idDocumentation ? d.idDocumentation.name : '',
          expiry_date: d.valid_until || null,
        }))
        this.loadingDocs = false
        this.recalcSemaforo()
      }).catch(() => { this.loadingDocs = false })
    },
    fetchDocsEmpresaStatus() {
      if (!this.empresa.id) return
      this.loadingDocs = true
      const config = {
        method: 'get',
        url: `https://empresa-service.intrare.app/company-documents/${this.empresa.id}/status/`,
        headers: { Authorization: 'Token ' + store.getters.getToken },
      }
      axios(config).then(res => {
        const docs = (res.data && res.data.documents) || []
        this.docsEmpresaStatus = docs
        this.semaforo.green  = docs.filter(d => d.status === 'OK').length
        this.semaforo.yellow = docs.filter(d => d.status === 'EXPIRED').length
        this.semaforo.red    = docs.filter(d => ['INVALID', 'MISSING'].includes(d.status)).length
        this.loadingDocs = false
      }).catch(() => { this.loadingDocs = false })
    },
    fetchCatalogo() {
      this.loadingCatalogo = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/documentations',
        headers: { Authorization: 'Token ' + store.getters.getToken },
      }
      axios(config).then(res => {
        this.catalogo = res.data
        this.catalogoOptions = res.data
        this.loadingCatalogo = false
      }).catch(() => { this.loadingCatalogo = false })
    },
    fetchDocumentations() {
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/documentations',
        headers: { Authorization: 'Token ' + store.getters.getToken },
      }
      axios(config).then(res => { this.documentations = res.data }).catch(() => {})
    },

    // ───────────────────── logo ─────────────────────
    handleLogoUpload() {
      const file = this.$refs.logoFile.files[0]
      if (!file) return
      this.logoOversized = file.size > LOGO_MAX_SIZE
      if (this.logoOversized) return
      const formData = new FormData()
      formData.append('logo', file)
      axios({
        method: 'patch',
        url: `https://empresa-service.intrare.app/empresas/${this.empresa.id}/update/`,
        headers: { Authorization: 'Token ' + store.getters.getToken, 'Content-Type': 'multipart/form-data' },
        data: formData,
      }).then(res => {
        this.empresa.logo = res.data.logo
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Logo actualizado correctamente.')
        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
      }).catch(() => {})
    },
    deleteLogo() {
      axios({
        method: 'patch',
        url: `https://empresa-service.intrare.app/empresas/${this.empresa.id}/update/`,
        headers: { Authorization: 'Token ' + store.getters.getToken },
        data: { logo: null },
      }).then(() => {
        this.empresa.logo = null
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', 'Logo eliminado.')
        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
      }).catch(() => {})
    },

    // ───────────────────── empresa datos ─────────────────────
    cancelEditEmpresa() {
      this.editingEmpresa = false
      this.fetchEmpresa()
    },
    saveEmpresa() {
      this.loadingSaveEmpresa = true
      axios({
        method: 'patch',
        url: `https://empresa-service.intrare.app/empresas/${this.empresa.id}/update/`,
        headers: { Authorization: 'Token ' + store.getters.getToken },
        data: { nombre: this.empresa.name, email: this.empresa.email, direccion: this.empresa.address },
      }).then(() => {
        this.loadingSaveEmpresa = false
        this.editingEmpresa = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Datos actualizados.')
        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
      }).catch(() => { this.loadingSaveEmpresa = false })
    },

    // ───────────────────── doc empresa ─────────────────────
    openUploadDialog() {
      this.editingDoc = false
      this.changeFile = false
      this.docFile = null
      this.docOversized = false
      this.docErrors = {}
      this.docForm = { idDocumentation: null, description: '', expiry_date: null }
      this.docOcrState = { file: null, loading: false, error: null, validUntil: null, ocrResult: null, skipped: false }
      this.dialogUpload = true
    },
    closeUploadDialog() {
      this.dialogUpload = false
      this.$refs.formUpload && this.$refs.formUpload.reset()
      this.docOcrState = { file: null, loading: false, error: null, validUntil: null, ocrResult: null, skipped: false }
    },
    resetOcrState() {
      this.docOcrState = { file: null, loading: false, error: null, validUntil: null, ocrResult: null, skipped: false }
      this.docOversized = false
      this.docFile = null
    },
    editDoc(item) {
      this.editingDoc = true
      this.changeFile = false
      this.docFile = null
      this.docOversized = false
      this.docErrors = {}
      this.docForm = { id: item.id, idDocumentation: item.idDocumentation_id, expiry_date: item.valid_until || item.expiry_date }
      this.dialogUpload = true
    },
    async handleDocFileUpload() {
      const input = this.$refs.docFileHidden
      const f = input && input.files && input.files[0]
      if (!f) return

      this.docOversized = f.size > MAX_FILE_SIZE
      if (this.docOversized) return

      this.docFile = f
      this.docOcrState = { file: f, loading: true, error: null, validUntil: null, ocrResult: null, skipped: false }

      // Determine OCR doc type
      const selectedDoc = this.companyDocOptions.find(d => d.id === this.docForm.idDocumentation)
      const docName = selectedDoc ? selectedDoc.name.toLowerCase() : ''
      let docType = null

      if (!this.ocrSupportedTypes.length) {
        await this.fetchOcrTypes()
      }

      if (this.ocrSupportedTypes.length && docName) {
        const match = this.ocrSupportedTypes.find(type => {
          const typeValue = typeof type === 'string' ? type : (type.type_id || type.type || '')
          const val = typeValue.toLowerCase()
          if (docName.includes(val)) return true
          if (docName.includes(val.replace(/_/g, ' '))) return true
          if (val === 'cedula_sua' && docName.includes('sua') && !docName.includes('comprobante')) return true
          if (val === 'linea_captura_imss' && (docName.includes('linea') || docName.includes('captura'))) return true
          if (val === 'opinion_cumplimiento' && docName.includes('opinion')) return true
          return false
        })
        if (match) docType = typeof match === 'string' ? match : (match.type_id || match.type)
      }

      if (!docType) {
        // No OCR support for this type — skip validation
        this.docOcrState = { file: f, loading: false, error: null, validUntil: null, ocrResult: null, skipped: true }
        return
      }

      try {
        const formData = new FormData()
        formData.append('document', f)
        formData.append('document_type', docType)
        const res = await axios.post('https://microservices.intrare.app/ocr/document/', formData, {
          headers: { 'Content-Type': 'multipart/form-data', 'x-api-key': '63f6f7729962518de2073625d1e61be17d5f99b5' }
        })
        const ocrResult = res.data
        let err = null
        if (!ocrResult.success) {
          err = ocrResult.errors ? ocrResult.errors.join(', ') : 'No se pudo validar el documento.'
        } else if (ocrResult.validations && ocrResult.validations.is_current === false) {
          err = 'Documento vencido.'
        }
        this.docOcrState = {
          file: f,
          loading: false,
          error: err,
          validUntil: (ocrResult.validations && ocrResult.validations.valid_until) || ocrResult.valid_until || null,
          ocrResult,
          skipped: false,
        }
      } catch (e) {
        this.docOcrState = { file: f, loading: false, error: 'Error al conectar con el servicio de validación.', validUntil: null, ocrResult: null, skipped: false }
      }
    },
    async fetchOcrTypes() {
      try {
        const res = await axios.get('https://microservices.intrare.app/ocr/document/types/',
          { headers: { 'x-api-key': '63f6f7729962518de2073625d1e61be17d5f99b5' } }
        )
        if (res.data && Array.isArray(res.data)) this.ocrSupportedTypes = res.data
        else if (res.data && Array.isArray(res.data.types)) this.ocrSupportedTypes = res.data.types
      } catch (e) { /* silently ignore */ }
    },
    saveDoc() {
      this.loadingUpload = true
      this.docErrors = {}
      const formData = new FormData()
      if (this.docFile) formData.append('file', this.docFile)

      const isEdit = this.editingDoc && this.docForm.id
      if (isEdit) {
        if (this.docOcrState.ocrResult) {
          const validationResult = {
            success: this.docOcrState.ocrResult.success,
            ocr_confidence: this.docOcrState.ocrResult.ocr_confidence || null,
            validations: this.docOcrState.ocrResult.validations || {},
            valid_until: this.docOcrState.validUntil || null,
            errors: this.docOcrState.ocrResult.errors || [],
            warnings: this.docOcrState.ocrResult.warnings || [],
            extracted_data: this.docOcrState.ocrResult.extracted_data || {},
          }
          formData.append('validation_result', JSON.stringify(validationResult))
        } else if (this.docOcrState.validUntil) {
          formData.append('valid_until', this.docOcrState.validUntil)
        } else if (this.docForm.expiry_date) {
          formData.append('valid_until', this.docForm.expiry_date)
        }
      } else {
        formData.append('documentation_id', this.docForm.idDocumentation)
        formData.append('empresa_id', this.empresa.id)
        if (this.docOcrState.ocrResult) {
          const validationResult = {
            success: this.docOcrState.ocrResult.success,
            ocr_confidence: this.docOcrState.ocrResult.ocr_confidence || null,
            validations: this.docOcrState.ocrResult.validations || {},
            valid_until: this.docOcrState.validUntil || null,
            errors: this.docOcrState.ocrResult.errors || [],
            warnings: this.docOcrState.ocrResult.warnings || [],
            extracted_data: this.docOcrState.ocrResult.extracted_data || {},
          }
          formData.append('validation_result', JSON.stringify(validationResult))
        }
      }

      axios({
        method: isEdit ? 'patch' : 'post',
        url: isEdit
          ? `https://empresa-service.intrare.app/company-documents/${this.docForm.id}/update/`
          : 'https://empresa-service.intrare.app/company-documents/upload/',
        headers: { Authorization: 'Token ' + store.getters.getToken, 'Content-Type': 'multipart/form-data' },
        data: formData,
      }).then(() => {
        this.loadingUpload = false
        this.closeUploadDialog()
        this.fetchDocsEmpresa()
        this.fetchDocsEmpresaStatus()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', isEdit ? 'Documento actualizado.' : 'Documento subido correctamente.')
        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
      }).catch(err => {
        this.loadingUpload = false
        if (err.response && err.response.status === 400 && err.response.data)
          this.docErrors = err.response.data
      })
    },
    viewDoc(item) {
      const url = item.file || item.url
      if (url) window.open(url, '_blank')
    },
    confirmDeleteDoc(item) {
      this.deleteTarget = item
      this.deleteType = 'doc'
      this.dialogDelete = true
    },

    // ───────────────────── catálogo ─────────────────────
    openCatalogoDialog() {
      this.editingCatalogo = false
      this.catErrors = {}
      this.catForm = { idDocumentation: null, name: '', description: '', is_company_document: false, displayName: '' }
      this.dialogCatalogo = true
    },
    closeCatalogoDialog() {
      this.dialogCatalogo = false
      this.$refs.formCatalogo && this.$refs.formCatalogo.reset()
    },
    editCatalogo(item) {
      this.editingCatalogo = true
      this.catErrors = {}
      this.catForm = { id: item.id, idDocumentation: item.id, name: item.name, description: item.description || '', is_company_document: !!item.is_company_document, displayName: item.name }
      this.dialogCatalogo = true
    },
    onCatalogDocumentChange(idDocumentation) {
      const selected = this.documentations.find(item => item.id === idDocumentation)
      if (!selected) return
      this.catForm.name = selected.name
      this.catForm.description = selected.description || ''
      this.catForm.displayName = selected.name
      this.catErrors = {}
    },
    saveCatalogo() {
      this.loadingCatalogo = true
      this.catErrors = {}
      const isEdit = this.editingCatalogo && this.catForm.id
      const selectedId = isEdit ? this.catForm.id : this.catForm.idDocumentation

      if (!selectedId) {
        this.loadingCatalogo = false
        this.catErrors = { idDocumentation: ['Seleccione un documento del catálogo.'] }
        return
      }

      axios({
        method: 'patch',
        url: `https://empresa-service.intrare.app/documentations/${selectedId}/`,
        headers: { Authorization: 'Token ' + store.getters.getToken, 'Content-Type': 'application/json', 'Accept-Language': this.language },
        data: { is_company_document: this.catForm.is_company_document },
      }).then(() => {
        this.loadingCatalogo = false
        this.closeCatalogoDialog()
        this.fetchCatalogo()
        this.fetchDocumentations()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Guardado correctamente.')
        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
      }).catch(err => {
        this.loadingCatalogo = false
        if (err.response && err.response.status === 400 && err.response.data) {
          this.catErrors = err.response.data
          if (err.response.data.non_field_errors)
            this.catErrors.idDocumentation = err.response.data.non_field_errors
        }
      })
    },
    confirmDeleteCatalogo(item) {
      this.deleteTarget = item
      this.deleteType = 'catalogo'
      this.dialogDelete = true
    },

    // ───────────────────── delete unificado ─────────────────────
    executeDelete() {
      this.loadingDelete = true
      let url = ''
      if (this.deleteType === 'doc')
        url = `https://empresa-service.intrare.app/company-documents/${this.deleteTarget.id}/delete/`
      else if (this.deleteType === 'catalogo')
        url = `https://empresa-service.intrare.app/documentation/Detail&Update&Delete/${this.deleteTarget.id}/`

      axios({
        method: 'delete',
        url,
        headers: { Authorization: 'Token ' + store.getters.getToken },
      }).then(() => {
        this.loadingDelete = false
        this.dialogDelete = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', 'Eliminado correctamente.')
        setTimeout(() => { this.$store.commit('snackbar_activate_false'); this.$store.commit('snackbar_change_color', 'success') }, 3000)
        if (this.deleteType === 'doc') { this.fetchDocsEmpresa(); this.fetchDocsEmpresaStatus() }
        else if (this.deleteType === 'catalogo') this.fetchCatalogo()
      }).catch(() => { this.loadingDelete = false })
    },
  },
}
</script>

<style scoped>
/* ── Hero header ────────────────────────────────────────────── */
.empresa-hero {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #002b48 0%, #004d80 60%, #0077b6 100%);
  min-height: 120px;
}
.empresa-hero__bg {
  position: absolute;
  top: -40px; right: -40px;
  width: 220px; height: 220px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  pointer-events: none;
}
.empresa-hero__content {
  position: relative;
  z-index: 1;
}
.empresa-hero__name { line-height: 1.2; }
.empresa-hero__sub  { opacity: .8; font-size: 0.9rem; }

/* ── Logo en el hero ─────────────────────────────────────────── */
.logo-wrapper {
  width: 80px; height: 80px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 3px solid rgba(255,255,255,0.4);
}
.logo-img { width: 100%; height: 100%; object-fit: cover; }

/* ── Semáforo chips en el hero ───────────────────────────────── */
.semaforo-chips { flex-wrap: wrap; }
.semaforo-chip  { font-weight: 600; letter-spacing: .3px; }
.semaforo-green  { background: #2e7d32 !important; color: #fff !important; }
.semaforo-yellow { background: #e65100 !important; color: #fff !important; }
.semaforo-red    { background: #c62828 !important; color: #fff !important; }

/* ── Semáforo cards ──────────────────────────────────────────── */
.semacard { border-radius: 10px !important; }
.semacard--green  { background: linear-gradient(135deg, #2e7d32, #43a047) !important; }
.semacard--yellow { background: linear-gradient(135deg, #e65100, #f57c00) !important; }
.semacard--red    { background: linear-gradient(135deg, #b71c1c, #e53935) !important; }

/* ── Logo preview en tab ─────────────────────────────────────── */
.logo-preview-wrapper {
  width: 160px; height: 160px;
  border-radius: 50%;
  border: 3px solid #002b48;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}
.logo-preview { width: 100%; height: 100%; object-fit: cover; }
.logo-placeholder {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; width: 100%; height: 100%;
}

/* ── Search field ────────────────────────────────────────────── */
.search-field { max-width: 380px; }

.catalog-card {
  border-radius: 10px;
  min-height: 140px;
}

.catalog-card--company {
  border-left: 4px solid #00897b;
  background: #f2fbf9;
}

.catalog-card--employee {
  border-left: 4px solid #1565c0;
  background: #f4f8ff;
}

.catalog-section-title {
  border-bottom: 1px solid #e0e0e0;
}

/* ── OCR upload dropzone ─────────────────────────────────────── */
.ocr-dropzone {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color .2s;
}
.ocr-dropzone:hover { border-color: #1976d2; }
.ocr-result-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}
</style>
